import { NgModule } from '@angular/core';
import { mapToCanActivate, RouterModule, Routes } from '@angular/router';
import { MaintenanceGuard } from './guards/maintenance.guard';

const routes: Routes = [
    {
        path: '',
        loadChildren: () => import('./modules/self-service/self-service.module').then((m) => m.SelfServiceModule),
        canActivate: mapToCanActivate([MaintenanceGuard]),
    },
    {
        path: 'setup',
        loadChildren: () =>
            import('./modules/business-partner-support/business-partner-support.module').then(
                (m) => m.BusinessPartnerSupportModule,
            ),
        canActivate: mapToCanActivate([MaintenanceGuard]),
    },
    {
        path: 'forgot-username',
        loadChildren: () =>
            import('./modules/forgot-username/forgot-username.module').then((m) => m.ForgotUsernameModule),
        canActivate: mapToCanActivate([MaintenanceGuard]),
    },
    {
        path: 'register',
        loadChildren: () =>
            import('./modules/register-customer/register-customer.module').then((m) => m.RegisterCustomerModule),
        canActivate: mapToCanActivate([MaintenanceGuard]),
    },
    {
        path: 'register-end-customer',
        loadChildren: () =>
            import('./modules/register-end-customer/register-end-customer.module').then(
                (m) => m.RegisterEndCustomerModule,
            ),
        canActivate: mapToCanActivate([MaintenanceGuard]),
    },
    {
        path: 'register-supplier',
        loadChildren: () =>
            import('./modules/register-supplier/register-supplier.module').then((m) => m.RegisterSupplierModule),
        canActivate: mapToCanActivate([MaintenanceGuard]),
    },
    {
        path: 'invitation-expired',
        loadChildren: () =>
            import('./modules/invitation-expired/invitation-expired.module').then((m) => m.InvitationExpiredModule),
        canActivate: mapToCanActivate([MaintenanceGuard]),
    },
    {
        path: 'invitation-used',
        loadChildren: () =>
            import('./modules/invitation-used/invitation-used.module').then((m) => m.InvitationUsedModule),
        canActivate: mapToCanActivate([MaintenanceGuard]),
    },
    {
        path: 'invitation-invalid',
        loadChildren: () =>
            import('./modules/invitation-invalid/invitation-invalid.module').then((m) => m.InvitationInvalidModule),
        canActivate: mapToCanActivate([MaintenanceGuard]),
    },
    {
        path: 'maintenance',
        loadChildren: () => import('./modules/maintenance/maintenance.module').then((m) => m.MaintenanceModule),
    },
    {
        path: 'access-denied',
        loadChildren: () => import('./modules/access-denied/access-denied.module').then((m) => m.AccessDeniedModule),
    },
    {
        path: '**',
        redirectTo: '',
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' })],
    exports: [RouterModule],
})
export class AppRoutingModule {}
